var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 53H16H1V39M27 53H28H39V39M39 29V15H27M17 15H1V29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53C24.6 53 24.5454 50.5607 25.5 49.874C27.0141 48.7848 28 47.0075 28 45C28 41.6863 25.3137 39 22 39C18.6863 39 16 41.6863 16 45C16 47.0075 16.9859 48.7848 18.5 49.874C19.5 50.5933 19.4 53 17 53",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15C24.6 15 24.5454 12.5607 25.5 11.874C27.0141 10.7848 28 9.00753 28 7C28 3.68629 25.3137 1 22 1C18.6863 1 16 3.68629 16 7C16 9.00753 16.9859 10.7848 18.5 11.874C19.5 12.5933 19.4 15 17 15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39C39 36.6 41.4393 36.5454 42.126 37.5C43.2152 39.0141 44.9925 40 47 40C50.3137 40 53 37.3137 53 34C53 30.6863 50.3137 28 47 28C44.9925 28 43.2152 28.9859 42.126 30.5C41.4067 31.5 39 31.4 39 29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39C1 36.6 3.4393 36.5454 4.12605 37.5C5.21522 39.0141 6.99247 40 9 40C12.3137 40 15 37.3137 15 34C15 30.6863 12.3137 28 9 28C6.99247 28 5.21523 28.9859 4.12605 30.5C3.40668 31.5 1 31.4 1 29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.a212e441.svg";
export { ForwardRef as ReactComponent };